import { QueryHookOptions, useQuery } from '@apollo/client'
import {
  ApplicationPhaseFragment,
  GetApplicationPhasesDocument,
  GetApplicationPhasesQuery,
  GetApplicationPhasesQueryVariables,
} from 'generated/resources/graphql'

export type ApplicationPhase = NonNullable<ApplicationPhaseFragment>
type Options = QueryHookOptions<GetApplicationPhasesQuery, GetApplicationPhasesQueryVariables>

export const useApplicationPhases = (options?: Options) => {
  const { data, loading } = useQuery(GetApplicationPhasesDocument, options)

  return {
    loading,
    applicationPhases: data ? (data.ats.applicationPhases as ApplicationPhase[]) : [],
  }
}
